import {ServiceBase} from '../ServiceBase';
import {IGamePreviewFeaturesSelectorService} from './game-preview-features-selector.service.interface';
import * as PF from './preview-features/all-features';
import {GameInfo} from '../games/game-info';
import {PreviewFeatureEvaluationResult, IGamePreviewFeature} from './preview-features/game-preview-feature.interface';
import { Check } from '@sparkware/app-utils';

export class GamePreviewFeaturesSelectorService extends ServiceBase implements IGamePreviewFeaturesSelectorService {
  private _gameGroupToFeatureMapping = {
    'VideoSlot': [PF.minBet, PF.maxBet, PF.hasJackpot, PF.numberOfLines, PF.hasBonusGames, PF.hasFreeSpins],
    'Roulette': [PF.minBet, PF.maxBet],
    'Blackjack': [PF.minBet, PF.maxBet, PF.numberOfDecks, PF.isMultiHand, PF.hasSideBets],
    'VideoPoker': [PF.minBet, PF.maxBet],
    'Keno': [PF.minBet, PF.maxBet],
    'Baccarat': [PF.minBet, PF.maxBet, PF.numberOfDecks],
    'PuntoBanco':[PF.minBet, PF.maxBet, PF.hasBonusGames],
    'Caribbean Poker': [PF.minBet, PF.maxBet, PF.hasJackpot, PF.isMultiHand],
    'Craps': [PF.minBet, PF.maxBet],
    'Live Casino': [PF.minBet, PF.maxBet],
    'Scratch Card': [PF.minBet, PF.maxBet]
  };

  getPreviewFeatures(gameInfo: GameInfo): PreviewFeatureEvaluationResult[] {
    let features: IGamePreviewFeature[] = this._gameGroupToFeatureMapping[gameInfo.gameGroup];
    if(!features) {
      this.services.logger.warning(`No preview features found for game ${gameInfo.gameType} - ${gameInfo.title} in game group ${gameInfo.gameGroup}`);
      return [];
    }

    let disabledFeatures: {[featureName: string]: boolean} = {};
    (this.services.configuration.data.generalSettings.gamesPreviewConfig?.disabledFeatures || []).forEach(
      feature => disabledFeatures[feature] = true
    );
 
    return features.filter(feature => !disabledFeatures[feature.name])
                    .map(feature => feature.evaluate(this.services, gameInfo))
                     .filter(feature => !Check.isNullOrUndefined(feature));
  }
}


